module.exports = __webpack_public_path__ + "static/media/machine3.d4a3a8cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/machine3.png
// module id = 864
// module chunks = 0